"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
var rxjs_1 = require("rxjs");
var LevelUp_1 = require("../../Views/LevelUp");
var LevelUp_2 = require("../LevelUp");
var Colliders_1 = require("../Colliders");
var app_1 = require("../../app");
var Drops_1 = require("../Drops");
var Minions_1 = require("../Minions");
var helpers_1 = require("../../helpers");
var Spells_1 = require("../Spells");
var Inputs_1 = require("../Inputs");
var Unit_1 = require("../Unit");
var FRICTION = 0.05;
var initialLevel = 0;
var initialExperience = 0;
var getNextLevelExp = function (level) {
    var nextLevel = Math.min(Object.keys(LevelUp_2.experienceTable).length, level + 1);
    return LevelUp_2.experienceTable[nextLevel];
};
var initializePlayer = function () {
    var app = app_1.appService.app;
    var player = (0, Unit_1.createUnit)("player", "naked", { x: app.screen.width / 2, y: app.screen.height / 2 });
    app_1.gameState.player = player;
    app_1.gameState.playerHealth.next({ current: player.health.getHP(), max: player.getStats().maxHP });
    player.health.subscribeToDeath(function () {
        app_1.gameState.transitionToScene("gameOver");
        app_1.appService.pause();
    });
    player.health.subscribeToHealthChange(function (_a) {
        var type = _a.type, amount = _a.amount;
        if (type === "damage") {
            app_1.gameState.incrementDamageTaken(amount);
        }
        app_1.gameState.playerHealth.next({ current: player.health.getHP(), max: player.getStats().maxHP });
    });
    var playerLevelSubject = new rxjs_1.BehaviorSubject({
        level: initialLevel,
        experience: initialExperience,
    });
    var onLevelUp = new rxjs_1.Subject();
    playerLevelSubject
        .pipe((0, rxjs_1.scan)(function (acc, curr) {
        var newExperience = acc.experience + curr.experience;
        var expToNextLevel = getNextLevelExp(acc.level);
        var levelUp = newExperience >= expToNextLevel;
        var level = levelUp ? acc.level + 1 : acc.level;
        var experience = levelUp
            ? newExperience - LevelUp_2.experienceTable[level]
            : newExperience;
        if (levelUp) {
            onLevelUp.next(level);
        }
        return { level: level, experience: experience };
    }, { level: initialLevel, experience: initialExperience }))
        .subscribe(function (_a) {
        var level = _a.level, experience = _a.experience;
        app_1.gameState.playerExpPercent.next({ current: experience, nextLevel: getNextLevelExp(level) });
    });
    var addExperience = function (experience) {
        playerLevelSubject.next({ experience: experience, level: 0 });
    };
    var levelUp = function () {
        if (player.level >= Object.keys(LevelUp_2.experienceTable).length)
            return;
        addExperience(LevelUp_2.experienceTable[player.level + 1]);
    };
    onLevelUp.subscribe(function (level) {
        console.log("Congratulations! You've reached level ".concat(level, "!"));
        app_1.appService.pause();
        player.level = level;
        (0, LevelUp_1.LevelUp)({
            level: level,
            options: (0, helpers_1.getRandomElements)((0, LevelUp_2.levelUpOptions)(app_1.gameState), 3),
        });
    });
    player.selectedSpell = "summon";
    return __assign(__assign({}, player), { levelUp: levelUp, addExperience: addExperience });
};
var spells = {
    sacrifice: function (sprite) {
        var sacrificialLamb = (0, helpers_1.getClosestUnit)(sprite, app_1.gameState.minions);
        if (sacrificialLamb) {
            sacrificialLamb.health.kill();
            app_1.gameState.minions.forEach(function (minion) { return minion.health.heal(5); });
            console.log("MURDERED");
        }
        else {
            console.log("NO LAMB FOUND");
        }
    },
};
var Player = function () {
    var physicsUpdate = app_1.appService.physicsUpdate, world = app_1.appService.world;
    app_1.gameState.player = initializePlayer();
    var player = app_1.gameState.player;
    var sprite = player.sprite;
    Inputs_1.keyDown$.subscribe(function (keydown) {
        if (keydown.key === '1')
            player.selectedSpell = "summon";
        if (keydown.key === '2')
            player.selectedSpell = "sacrifice";
    });
    // state
    var _a = [0, 0], moveX = _a[0], moveY = _a[1];
    // TODO: implement a state machine to manage player state
    var handleInput = function (_a) {
        var _b;
        var x = _a.x, y = _a.y, casting = _a.casting;
        // forbid player actions while paused
        if (app_1.appService.paused)
            return;
        if (casting) {
            if (!((_b = player.castingSpell) === null || _b === void 0 ? void 0 : _b.casting)) {
                if (player.selectedSpell === "summon") {
                    var offset_1 = { x: 0, y: sprite.height / 2 };
                    player.castingSpell = (0, Spells_1.RadialSpell)({
                        position: sprite,
                        offset: offset_1,
                        endSize: player.getStats().spellRadius,
                        growth: player.getStats().castingSpeed,
                        canBeHeld: true,
                        onComplete: function () {
                            player.castingSpell = null;
                        },
                        successCondition: function (radius) { return radius > 25; },
                        onSuccess: function (radius) {
                            var _a;
                            (_a = app_1.gameState.items.bones) === null || _a === void 0 ? void 0 : _a.map(function (b) {
                                if ((0, Colliders_1.distanceBetweenPoints)(b.sprite, { x: sprite.x, y: sprite.y + offset_1.y }) <= radius + b.sprite.width / 2) {
                                    (0, Minions_1.createMinion)(b.sprite);
                                    (0, Drops_1.removeItem)("bones", b);
                                }
                            });
                        },
                        color: "FFAAFF",
                    });
                }
                else {
                    player.castingSpell = (0, Spells_1.CastBar)({
                        sprite: sprite,
                        onComplete: function () {
                            console.log("DONE");
                            player.castingSpell = null;
                        },
                        onSuccess: function () {
                            console.log("CAST SPELL");
                            spells[player.selectedSpell](sprite);
                        },
                        castTime: 1,
                    });
                }
                /*
                player.castingSpell = RectangularSpell({
                  position: sprite,
                  maxWidth: 100,
                  growth: 0.5,
                  canBeHeld: true,
                  onComplete: (width) => {
                    console.log("COMPLETED SPELL: " + width);
                    player.vx += 50;
                    player.castingSpell = null;
                  },
                  target: items.bones[0].sprite,
                })
                */
            }
            moveX = 0;
            moveY = 0;
        }
        else {
            if (player.castingSpell) {
                player.castingSpell.resolveSpell();
            }
            moveX = x;
            moveY = y;
        }
    };
    playerInput$.subscribe(function (e) { return handleInput(e); });
    // apply x and y state to move player
    physicsUpdate.subscribe(function (delta) {
        var _a = (0, helpers_1.normalizeForce)({ x: moveX, y: moveY }), x = _a.x, y = _a.y;
        if (x === 0) {
            sprite.vx += -sprite.vx * FRICTION * delta;
        }
        else {
            sprite.vx += x * player.getStats().moveSpeed * delta;
        }
        if (y === 0) {
            sprite.vy += -sprite.vy * FRICTION * delta;
        }
        else {
            sprite.vy += y * player.getStats().moveSpeed * delta;
        }
        // limit max speed
        var magnitude = Math.sqrt(sprite.vx * sprite.vx + sprite.vy * sprite.vy);
        if (magnitude > player.getStats().maxSpeed) {
            var scale = player.getStats().maxSpeed / magnitude;
            sprite.vx *= scale;
            sprite.vy *= scale;
        }
        sprite.x += sprite.vx;
        sprite.y += sprite.vy;
        world.pivot.x = sprite.x;
        world.pivot.y = sprite.y;
    });
};
exports.Player = Player;
// converting input to x/y values
var playerInput$ = Inputs_1.activeKeys$.pipe((0, rxjs_1.map)(function (keys) { return ({
    casting: keys[' '],
    x: (keys['d'] ? 1 : 0) + (keys['a'] ? -1 : 0),
    y: (keys['s'] ? 1 : 0) + (keys['w'] ? -1 : 0),
}); }), (0, rxjs_1.startWith)({ x: 0, y: 0 }));
